import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { useHistory } from "react-router-dom";
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import React from 'react';

export const RolesPage = () => {

    let emptyRole = {
        id: null,
        name: '',
        image: null,
        description: '',
        category: null,
        price: 0,
        quantity: 0,
        rating: 0,
        inventoryStatus: 'INSTOCK'
    };
    
    const [roles, setRoles] = React.useState(null);
    const [globalFilter, setGlobalFilter] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [role, setRole] = React.useState(emptyRole);
    const [deleteRoleDialog, setDeleteRoleDialog] = React.useState(false);
    
    const toast = React.useRef(null);

    let history = useHistory();

    React.useEffect(() => {

        const requestPayload = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*' ,
                'Authorization': 'Bearer ' +localStorage.getItem('jwt')
            }
        }

        fetch('https://springboot-widy-app.widyan123.site/widy-app/role/all', requestPayload)
        .then(res => {
            if(res.status >= 400 && res.status <= 599) {
                console.log('HTTP ', res.status);
                return Promise.reject(res);
            } else {
                console.log('HTTP ', res.status);
                return Promise.resolve(res);
            }            
        })
        .then(res => res.json())
        .then(res => {
            setRoles(res.data);
            setLoading(false);
        })
        .catch(res => {
            console.log("catch ", res);
            if(res.status === 401) {
                history.push('/login');
            } else {
                console.log("catch: ", res);
                setLoading(false);
            }            
        });
    }, []);

    

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        )
    }

    const openNew = () => {
        history.push({
            pathname: '/role',
            state: {
                todo: 'Tambah'
            }
        });
    }

    const openEdit = (rowData) => {
        history.push({
            pathname: '/role',
            state: {
                todo: 'Ubah',
                dataRole: rowData
            }
        });
    }

    const confirmDeleteRole = (role) => {
        setRole(role);
        setDeleteRoleDialog(true);
    }

    const roleTableHeader = (
        <div className="table-header">
            List of Roles
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
            </span>
        </div>
    );

    const bodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]}
            </>
        );
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => openEdit(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => confirmDeleteRole(rowData)} />
            </div>
        );
    }

    const hideDeleteRoleDialog = () => {
        setDeleteRoleDialog(false);
    }

    async function deleteRoleBackEnd(role) {
        const requestPayload = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*' ,
                'Authorization': 'Bearer ' +localStorage.getItem('jwt')
            }

        }         
          
        const response = await fetch(`http://147.93.111.86:8082/widy-app/role/delete/${role.id}`, requestPayload);        
        const res = await response.json();
        console.log('response', res);
        if(response.status >= 200 && response.status <= 299) {
            toast.current.show({ severity: 'success', summary: 'Successful', detail: res.message, life: 3000 });
        } else if(response.status >= 400 && response.status <= 499) {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: res.message, life: 3000 });
        } else {
            toast.current.show({ severity: 'error', summary: 'Error', detail: res.message, life: 3000 });
        }
    }

    const deleteRole = () => {
        let _roles = roles.filter(val => val.id !== role.id);
        setRoles(_roles);
        setDeleteRoleDialog(false);
        setRole(emptyRole);
        deleteRoleBackEnd(role);
    }

    const deleteRoleDialogFooter = (
        <>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteRoleDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteRole} />
        </>
    );

    return (
        <div className="grid table-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="mb-4" left={leftToolbarTemplate}></Toolbar>
                    <DataTable value={roles} scrollable scrollHeight="600px" className="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-customers" dataKey="id" rowHover
                        globalFilter={globalFilter} emptyMessage="No customers found." loading={loading} header={roleTableHeader}>
                        <Column field="name" header="Name" sortable body={bodyTemplate}></Column>
                        <Column header="Action" body={actionBodyTemplate}></Column>
                    </DataTable>

                    <Dialog visible={deleteRoleDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteRoleDialogFooter} onHide={hideDeleteRoleDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {role && <span>Are you sure you want to delete <b>{role.name}</b>?</span>}
                        </div>
                    </Dialog>
                </div>
            </div>
        </div>
    )
}
